var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { TableExpandableRow as EdsTableExpandableRow } from '@hedtech/react-design-system/core/es/Table';
const TableExpandableRow = (props, ref) => {
    const { children } = props, rest = __rest(props, ["children"]);
    return (React.createElement(EdsTableExpandableRow, Object.assign({ ref: ref }, rest), children));
};
const TableExpandableRowFRC = forwardRef(TableExpandableRow);
TableExpandableRowFRC.displayName = 'TableExpandableRowFRC';
export default TableExpandableRowFRC;
